import api from '../../config/api';
import { getJsonResponse } from '../../utils/ApiUtils';
import { Item } from 'src/interfaces/api/ActivityWall';
import { Order } from '../../interfaces/Table';
import { CollectionResponse } from '../../interfaces/api/api';
import useAuth from './useAuth';

const useActivityWall = () => {
  const { fetch } = useAuth();

  const getItems = async (
    wallId: string,
    criteria: Object,
    orderBy: string,
    order: Order
  ): Promise<CollectionResponse<Item>> => {
    const { endpoint, ...options } = api.activityWall.getItems(wallId, criteria, orderBy, order);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Item>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const addPost = async (wallId: string, title: string, comment: string, attachments?: File[]): Promise<Item> => {
    const { endpoint, ...options } = api.activityWall.addItem(wallId, 'POST', { comment, title }, attachments);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Item>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const editPost = async (wallId: string, itemId: string, title: string, comment: string): Promise<Item> => {
    const { endpoint, ...options } = api.activityWall.editItem(wallId, itemId, { comment, title });

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Item>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const removePost = async (wallId: string, itemId: string): Promise<Response> => {
    const { endpoint, ...options } = api.activityWall.removeItem(wallId, itemId);

    const response = await fetch(endpoint, options);

    try {
      return getJsonResponse(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const removeItemAttachment = async (wallId: string, itemId: string, attachmentId: string): Promise<Response> => {
    const { endpoint, ...options } = api.activityWall.removeItemAttachment(wallId, itemId, attachmentId);

    const response = await fetch(endpoint, options);

    try {
      return getJsonResponse(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const addItemAttachment = async (wallId: string, itemId: string, file: File): Promise<Item> => {
    const { endpoint, ...options } = api.activityWall.addItemAttachment(wallId, itemId, file);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Item>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getItems, removeItemAttachment, addItemAttachment, addPost, editPost, removePost };
};

export default useActivityWall;
